import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, apiError } from "@/lib/api";
import { fmtMoney } from "@/lib/format";

const fmtDay = (iso) => (iso ? new Date(iso).toLocaleDateString("fr-FR", { day: "numeric", month: "short", year: "numeric" }) : "—");

export default function AdminClubs() {
  const [list, setList] = useState(null);
  const [invite, setInvite] = useState(null);
  const genInvite = async () => {
    try { const { data } = await api.post("/admin/invites"); setInvite(data.url); } catch (e) { toast.error(apiError(e)); }
  };
  const copyInvite = async () => { try { await navigator.clipboard.writeText(invite); toast.success("Lien copié"); } catch { toast.error("Copiez le lien manuellement"); } };
  useEffect(() => { api.get("/admin/clubs").then((r) => setList(r.data)).catch((e) => toast.error(apiError(e))); }, []);

  const toggle = async (c) => {
    const disabled = !c.disabled;
    if (disabled && !window.confirm(`Désactiver « ${c.name} » ? Ses membres ne pourront plus se connecter.`)) return;
    try {
      await api.patch(`/admin/clubs/${c.id}`, { disabled });
      setList((l) => l.map((x) => (x.id === c.id ? { ...x, disabled } : x)));
      toast.success(disabled ? "Club désactivé" : "Club réactivé");
    } catch (e) { toast.error(apiError(e)); }
  };

  return (
    <section data-testid="admin-clubs">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight">Clubs inscrits</h1>
      <p className="text-sm text-[#5B665F] mt-2" data-testid="admin-clubs-count">{list ? `${list.length} club${list.length > 1 ? "s" : ""}` : "Chargement…"}</p>
      <div className="card p-5 mt-6" data-testid="admin-invite-block">
        <button className="btn-primary btn-sm" onClick={genInvite} data-testid="admin-generate-invite">Générer un lien de création</button>
        {invite && (
          <div className="flex flex-col sm:flex-row gap-2 mt-3">
            <input readOnly className="field h-10 text-xs" value={invite} onFocus={(e) => e.target.select()} data-testid="admin-invite-url" />
            <button className="btn-outline h-10" onClick={copyInvite} data-testid="admin-invite-copy">Copier</button>
          </div>
        )}
        <p className="text-xs text-[#5B665F] mt-2">Lien unique, valable 30 jours, permettant de créer un seul club.</p>
      </div>
      <div className="card mt-8 overflow-x-auto">
        <table className="w-full text-sm min-w-[860px]">
          <thead className="bg-[#F8F9F6] text-[#5B665F] text-[13px]">
            <tr>{["Club", "Saison", "Responsable", "Email du compte", "Inscription", "Sponsors", "Montant saison", "Statut", ""].map((h, i) => <th key={i} className="text-left font-medium px-4 py-3">{h}</th>)}</tr>
          </thead>
          <tbody>
            {list?.map((c) => (
              <tr key={c.id} className={`border-t border-[#E1E4DD] ${c.disabled ? "opacity-60" : ""}`} data-testid={`club-row-${c.id}`}>
                <td className="px-4 py-3 font-semibold">{c.name}{c.is_demo && <span className="pill bg-[#EEF0EB] text-[#5B665F] ml-2">Démo</span>}</td>
                <td className="px-4 py-3 whitespace-nowrap">{c.season}</td>
                <td className="px-4 py-3">{c.manager_name || "—"}</td>
                <td className="px-4 py-3">{c.email ? <a href={`mailto:${encodeURIComponent(c.email)}`} className="link">{c.email}</a> : "—"}</td>
                <td className="px-4 py-3 whitespace-nowrap">{fmtDay(c.created_at)}</td>
                <td className="px-4 py-3">{c.sponsors}</td>
                <td className="px-4 py-3 whitespace-nowrap">{fmtMoney(c.total_amount)}</td>
                <td className="px-4 py-3"><span className={`pill ${c.disabled ? "bg-[#FDEBD3] text-[#8A4B00]" : "bg-[#DFF3E6] text-[#145A36]"}`} data-testid={`club-status-${c.id}`}>{c.disabled ? "Désactivé" : "Actif"}</span></td>
                <td className="px-4 py-3 text-right"><button className="btn-outline btn-sm" onClick={() => toggle(c)} data-testid={`club-toggle-${c.id}`}>{c.disabled ? "Réactiver" : "Désactiver"}</button></td>
              </tr>
            ))}
            {list?.length === 0 && <tr><td colSpan={9} className="px-4 py-6 text-[#5B665F]">Aucun club.</td></tr>}
          </tbody>
        </table>
      </div>
    </section>
  );
}
